/* template */
<template><div :style="[(polyfillPageStyle)] | transRpxStyle" class="polyfill-page"><div class="loading-page" v-if="(type==='loading')"><mpx-image :src="(loadingImageUrl)" alt="加载中" class="loading-img" v-if="(loadingImageUrl)"></mpx-image><div class="context title">{{ loadingContext }}</div></div><div class="loading-page" v-else-if="(type==='category-loading')"><div :class="(centerMoveUp ? 'category-loading-center-ios' : '')" class="category-loading-center"><mpx-image :src="(loadingImageUrl)" class="category-loading-img" v-if="(loadingImageUrl)"></mpx-image><div class="context title" v-if="(categoryLoadingTitle)">{{
          categoryLoadingTitle
        }}</div><div class="context desc" v-if="(categoryLoadingDesc)">{{ categoryLoadingDesc }}</div><div class="loading-progress"><div :class="(selectedIndex == 0?'circle-current':'circle-normal')" class="circle"></div><div :class="(selectedIndex == 1?'circle-current':'circle-normal')" class="circle"></div><div :class="(selectedIndex == 2?'circle-current':'circle-normal')" class="circle"></div></div></div></div><div class="blank-page" v-else-if="(type==='blank-page')"><mpx-image :src="(blankImageUrl)" alt="无数据图片" class="blank-img" v-if="(blankImageUrl)"></mpx-image><div class="context"><slot name="blankContextTitle" v-if="(setBlankContext)"></slot><div :style="[(blankTitleStyle)] | transRpxStyle" class="title" v-else>{{ blankContextTitle }}</div><div :style="[(blankSubtitleStyle)] | transRpxStyle" class="sub-title" v-if="(hasSubTitle)">{{ blankContextSubTitle }}</div></div><div v-if="(hasButton)"><mpx-view @tap="clickButton" class="blank-button-Context">{{ blankButtonContext }}</mpx-view></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m15c39454"}'>
  .polyfill-page
    overflow hidden
  .loading-page
    display flex
    align-items center
    flex-direction column
    height 100%
  .blank-page, .context
    display flex
    align-items center
    flex-direction column
    font-size 14px
    color #333333
  .loading-img
    height 24px
    width 24px
    margin 276px 0px 0px 0px
  .category-loading-center
    display flex
    flex-direction column
    justify-content center
    align-items center
    height 100%
  .category-loading-center-ios
    margin-top -62px
  .category-loading-img
    height 60px
    width 60px
  .title
    margin-top 16px
    line-height 20px
  .sub-title
    text-align center
    line-height 20px
  .blank-page .blank-img
    height 100px
    width 100px
    margin-top 120px
  .blank-button-Context
    font-size 13px
    padding 9px 27px
    margin-top 24px
    line-height 13px
    color #1473FF
    position relative
    border-color #1473FF
  .blank-button-Context::after
    content ''
    position absolute
    top -50%
    bottom -50%
    left -50%
    right -50%
    border 1px solid
    border-radius 6px
    box-sizing border-box
    transform scale(0.5)
  .loading-progress
    margin-top 16px
    height 8px
    width 100%
    display flex
    justify-content center
    margin-right 10px
  .circle
    width 8px
    height 8px
    border-radius 4px
    margin-left 10px
  .circle-normal
    background-color rgba(153, 153, 153, 0.2)
  .circle-current
    background-color #999999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m15c39454"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex15c39454%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex15c39454%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m15c39454"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index15c39454/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
